export enum actionTypes {
    FETCH_INIT = 'FETCH_INIT',
    FETCH_SUCCESS = 'FETCH_SUCCESS',
    FETCH_FAILURE = 'FETCH_FAILURE',
    RESET_STATE = 'RESET_STATE',
    RESET_LOADING = 'RESET_LOADING'
}
